import { useDataValue, useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let selected = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
  })
  let personMatches = useDataValue({
    viewPath: props.viewPath,
    context: 'person_matches',
  })
  let submit = useDataSubmit({
    context: 'person_matches',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    if (selected.type === 'lead') {
      return submit({ type: 'useSelectedLead', id: selected.id })
    }

    let person = personMatches.find(item => item.id === selected.id)
    if (person.patient?._id) {
      return submit({
        type: 'useSelectedPatient',
        id: person.patient._id,
        person: {
          id: person._id,
          first_name: person.first_name,
          last_name: person.last_name,
          greeting: person.greeting,
        },
      })
    }

    return submit({ type: 'useSelectedPerson', id: person.vaxiom_id })
  }
}
